// this file can be imported to avoid repeating routes manually in multiple files

export const ROUTES = {
  holdings: '/holdings',
  holdingsTaxLots: '/holdings/tax-lots',
  allTransactions: '/all-transactions',
  manualEntry: '/all-transactions/add',
  allTransfers: '/all-transfers',
  imports: '/imports',
  importsAdd: '/imports/add',
  importsEdit: '/imports/:credentialId',
  documents: '/documents',
  documentsTable: '/documents/table',
  documentsCsvUploads: '/documents/csv-uploads',
  documents1099DA: '/documents/1099-da',
  movements: '/recon/cost-basis/movements',
  selfReconCostBasisAccounts: '/recon/cost-basis/accounts',
  taxDetails: '/settings/tax-details',
  upgrade: '/purchase',
  checkoutSuccessful: '/checkout-successful', // this is the "Confirmation page" set on Stripe - see settings page for each for Payment Link
};
